import { api } from "../Configurations/axios";

const CreatePathAPI = async (pathName: string, companyId: string, pathMain: string, path: string, userEmail: string) => {
    try {
        const result = await api.post("/PathManager/CreatePath", { pathName: pathName, companyId: companyId, pathMain: pathMain, path: path, userEmail: userEmail });
        const response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const GetSubPathsAPI = async (companyId: string, pathMain: string, pathId: string, page: number, take: number, word: string) => {
    try {
        const result = await api.get(`/PathManager/GetSubPath/?companyId=${companyId}&pathMain=${pathMain}&pathId=${pathId}&page=${page}&take=${take}&word=${encodeURIComponent(word)}`);
        const response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const GetSubPathNameAPI = async (pathId: string, companyId: string) => {
    try {
        const result = await api.get(`/PathManager/GetSubPathName/?pathId=${pathId}&companyId=${companyId}`);
        const response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const DeletePathAPI = async (pathId: string, companyId: string, pathMain: string) => {
    try {
        const result = await api.delete("/PathManager/DeleteSubPath", { data: { pathId: pathId, companyId: companyId, pathMain: pathMain } });
        const response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const EditPathAPI = async (pathName: string, pathId: string, userEmail: string, pathMain: string, pathParentId: string, companyId: string) => {
    try {
        const result = await api.put("/PathManager/EditSubPath", { pathId: pathId, userEmail: userEmail, pathName: pathName, pathMain: pathMain, pathParentId: pathParentId, companyId: companyId });
        const response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

export { 
    CreatePathAPI,
    GetSubPathsAPI,
    GetSubPathNameAPI,
    DeletePathAPI,
    EditPathAPI
}